import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import PerformanceMonitor from './components/PerformanceMonitor';
import LoadingSpinner from './components/LoadingSpinner';
import './App.css';

// Lazy load components for better performance
const Hero = React.lazy(() => import('./components/Hero'));
const Features = React.lazy(() => import('./components/Features'));
const HowItWorks = React.lazy(() => import('./components/HowItWorks'));
const Security = React.lazy(() => import('./components/Security'));
const Download = React.lazy(() => import('./components/Download'));
const Contact = React.lazy(() => import('./pages/Contact'));
const PrivacyPolicy = React.lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = React.lazy(() => import('./pages/TermsOfService'));

const App = () => {
  useEffect(() => {
    // Register service worker for PWA functionality - DISABLED for debugging
    // if ('serviceWorker' in navigator) {
    //   window.addEventListener('load', () => {
    //     navigator.serviceWorker.register('./sw.js')
    //       .then((registration) => {
    //         // eslint-disable-next-line no-console
    //         console.log('SW registered: ', registration);
    //       })
    //       .catch((registrationError) => {
    //         // eslint-disable-next-line no-console
    //         console.log('SW registration failed: ', registrationError);
    //       });
    //   });
    // }

    // Performance monitoring - DISABLED for debugging
    // if (process.env.NODE_ENV === 'production') {
    //   PerformanceMonitor.init();
    // }
  }, []);

  const pageVariants = {
    initial: {
      opacity: 0,
      y: 20
    },
    in: {
      opacity: 1,
      y: 0
    },
    out: {
      opacity: 0,
      y: -20
    }
  };

  const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.4
  };

  return (
    <ErrorBoundary>
      <Router>
        <div className="App">
          <Navigation />
          
          <main id="main-content" role="main">
            <AnimatePresence mode="wait">
              <Routes>
                <Route 
                  path="/" 
                  element={
                    <motion.div
                      key="home"
                      initial="initial"
                      animate="in"
                      exit="out"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                      <Suspense fallback={<LoadingSpinner />}>
                        <Hero />
                        <Features />
                        <HowItWorks />
                        <Security />
                        <Download />
                      </Suspense>
                    </motion.div>
                  } 
                />
                
                <Route 
                  path="/contact" 
                  element={
                    <motion.div
                      key="contact"
                      initial="initial"
                      animate="in"
                      exit="out"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                      <Suspense fallback={<LoadingSpinner />}>
                        <Contact />
                      </Suspense>
                    </motion.div>
                  } 
                />
                
                <Route 
                  path="/privacy" 
                  element={
                    <motion.div
                      key="privacy"
                      initial="initial"
                      animate="in"
                      exit="out"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                      <Suspense fallback={<LoadingSpinner />}>
                        <PrivacyPolicy />
                      </Suspense>
                    </motion.div>
                  } 
                />
                
                <Route 
                  path="/terms" 
                  element={
                    <motion.div
                      key="terms"
                      initial="initial"
                      animate="in"
                      exit="out"
                      variants={pageVariants}
                      transition={pageTransition}
                    >
                      <Suspense fallback={<LoadingSpinner />}>
                        <TermsOfService />
                      </Suspense>
                    </motion.div>
                  } 
                />
              </Routes>
            </AnimatePresence>
          </main>
          
          <Footer />
        </div>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
